import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import styles from './PrivacyPolicyPage.module.scss';

const PrivacyPolicyPage = () => {
  return (
    <>
      <SEO 
        title="Privacy Policy - mobiyo"
        description="Read our privacy policy to understand how mobiyo collects, uses, and protects your information when you use our mobile application review management service."
        keywords="privacy policy, data protection, user privacy, mobile app reviews, data security"
        canonical="https://mobiyo.app/privacy-policy"
      />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              At mobiyo, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application review management service.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>
              We collect information that you provide directly to us, including:
            </p>
            <ul>
              <li>Account information (name, email address)</li>
              <li>Mobile application data and reviews</li>
              <li>Communication preferences</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>
              We use the collected information to:
            </p>
            <ul>
              <li>Provide and maintain our services</li>
              <li>Process your requests and transactions</li>
              <li>Send you technical notices and support messages</li>
              <li>Improve our services and develop new features</li>
            </ul>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2>5. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
              <br />
              Email: team@mobiyo.app
            </p>
          </section>

          <div className={styles.backLink}>
            <Link to="/">← Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyPage; 
